export default __webpack_public_path__ + "static/media/6.68e1f126.jpg";